export const RxButton = {
  styleOverrides: {
    root: {
      borderRadius: 2,
    },
    outlined: {
      border: '1px solid #1b202f',
    },
  },
};
